import { WORKFLOW_SCROLL_CONTAINER } from './workflow-scroll.constants';

export const scrollWorkflowToTop = (overlay: HTMLElement | null): void => {
  const scrollContainer = overlay?.querySelector<HTMLElement>(WORKFLOW_SCROLL_CONTAINER);
  if (scrollContainer) {
    scrollContainer.scrollTop = 0;
  }
};
